
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletter/unsubscribe",
      function () {
        return require("private-next-pages/newsletter/unsubscribe/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletter/unsubscribe"])
      });
    }
  